export default "__VITE_PUBLIC_ASSET__a10b9297__"